import { Component, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { OKTA_AUTH } from '@okta/okta-angular';
import OktaAuth from '@okta/okta-auth-js';

@Component({
  selector: 'app-unauthorized',
  standalone: false,
  templateUrl: './unauthorized.component.html',
  styleUrls: ['./unauthorized.component.scss']
})
export class UnauthorizedComponent {
  constructor(@Inject(OKTA_AUTH) public oktaAuth: OktaAuth) {}

  async logInAgain() {
    await this.oktaAuth.signOut({ // Note the 'await' here
      postLogoutRedirectUri: ''
    })
    .catch((err) => {
      console.log(err);
    });
  }
}
